import React, { useEffect } from 'react'

import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter, useLocation } from 'react-router-dom'

import { ThemeProvider } from '@mui/material'

import { AuthProvider } from './containers/authContext'
import { theme } from './lib/mui'

import Routers from './routes'

import './App.css'

const AppShell: React.FC = () => {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname, search, hash])

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Routers />
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  )
}

export default App
